import { CourseOutlineFragment } from "@src/features/contentDetail/premiumModuleDetail/PremiumModuleDetailContainer.generated";
import {
  ModuleBuilderContentMembershipFragment,
  ModuleBuilderCourseFragment,
  ModuleBuilderFileFragment,
  ModuleBuilderModuleVersionFragment,
  ModuleBuilderScormCourseFragment,
  ModuleBuilderSkillFragment,
  SectionBreakFragment,
} from "../ModuleDetailPageContainer.generated";

export const getMembershipScreenId = (membershipUuid: string): string =>
  membershipUuid;

export class ModuleMembershipSectionItems {
  readonly id: string;
  readonly items: ModuleMembershipItemData[];
  constructor(id: string, items: ModuleMembershipItemData[]) {
    this.id = id;
    this.items = items;
  }
}

export class ModuleMembershipItemData {
  readonly id: string;
  readonly fractionPosition: number;
  readonly moduleVersion: ModuleBuilderModuleVersionFragment;
  readonly membership: ModuleBuilderContentMembershipFragment;
  readonly validationErrorCount: number;
  constructor(
    id: string,
    fractionPosition: number,
    moduleVersion: ModuleBuilderModuleVersionFragment,
    membership: ModuleBuilderContentMembershipFragment,
    validationErrorCount: number,
  ) {
    this.id = id;
    this.fractionPosition = fractionPosition;
    this.moduleVersion = moduleVersion;
    this.membership = membership;
    this.validationErrorCount = validationErrorCount;
  }
}

export class SectionBreakMembershipItemData extends ModuleMembershipItemData {
  readonly sectionBreak: SectionBreakFragment;
  constructor(
    id: string,
    fractionPosition: number,
    moduleVersion: ModuleBuilderModuleVersionFragment,
    membership: ModuleBuilderContentMembershipFragment,
    validationErrorCount: number,
    sectionBreak: SectionBreakFragment,
  ) {
    super(
      id,
      fractionPosition,
      moduleVersion,
      membership,
      validationErrorCount,
    );
    this.sectionBreak = sectionBreak;
  }
}

export class ContentMembershipItemData extends ModuleMembershipItemData {
  constructor(
    id: string,
    fractionPosition: number,
    moduleVersion: ModuleBuilderModuleVersionFragment,
    membership: ModuleBuilderContentMembershipFragment,
    validationErrorCount: number,
  ) {
    super(
      id,
      fractionPosition,
      moduleVersion,
      membership,
      validationErrorCount,
    );
  }
}

export class CourseContentMembershipItemData extends ContentMembershipItemData {
  course: ModuleBuilderCourseFragment;
  validationErrorCount: number;
  constructor(
    id: string,
    fractionPosition: number,
    moduleVersion: ModuleBuilderModuleVersionFragment,
    membership: ModuleBuilderContentMembershipFragment,
    validationErrorCount: number,
    course: ModuleBuilderCourseFragment,
  ) {
    super(
      id,
      fractionPosition,
      moduleVersion,
      membership,
      validationErrorCount,
    );
    this.course = course;
    this.validationErrorCount = validationErrorCount;
  }
}

export class FileContentMembershipItemData extends ContentMembershipItemData {
  file: ModuleBuilderFileFragment;
  constructor(
    id: string,
    fractionPosition: number,
    moduleVersion: ModuleBuilderModuleVersionFragment,
    membership: ModuleBuilderContentMembershipFragment,
    validationErrorCount: number,
    file: ModuleBuilderFileFragment,
  ) {
    super(
      id,
      fractionPosition,
      moduleVersion,
      membership,
      validationErrorCount,
    );
    this.file = file;
  }
}

export class ScormCourseContentMembershipItemData extends ContentMembershipItemData {
  scormCourse: ModuleBuilderScormCourseFragment;
  constructor(
    id: string,
    fractionPosition: number,
    moduleVersion: ModuleBuilderModuleVersionFragment,
    membership: ModuleBuilderContentMembershipFragment,
    validationErrorCount: number,
    scormCourse: ModuleBuilderScormCourseFragment,
  ) {
    super(
      id,
      fractionPosition,
      moduleVersion,
      membership,
      validationErrorCount,
    );
    this.scormCourse = scormCourse;
  }
}

export class SkillContentMembershipItemData extends ContentMembershipItemData {
  skill: ModuleBuilderSkillFragment;
  constructor(
    id: string,
    fractionPosition: number,
    moduleVersion: ModuleBuilderModuleVersionFragment,
    membership: ModuleBuilderContentMembershipFragment,
    validationErrorCount: number,
    skill: ModuleBuilderSkillFragment,
  ) {
    super(
      id,
      fractionPosition,
      moduleVersion,
      membership,
      validationErrorCount,
    );
    this.skill = skill;
  }
}

export class courseOutlineContentMembershipItemData extends ContentMembershipItemData {
  courseOutline: CourseOutlineFragment;
  constructor(
    id: string,
    fractionPosition: number,
    moduleVersion: ModuleBuilderModuleVersionFragment,
    membership: ModuleBuilderContentMembershipFragment,
    validationErrorCount: number,
    courseOutline: CourseOutlineFragment,
  ) {
    super(
      id,
      fractionPosition,
      moduleVersion,
      membership,
      validationErrorCount,
    );
    this.courseOutline = courseOutline;
  }
}
